import Navbar from "@/components/navbar/Navbar";
import { Outlet } from "react-router-dom";

const NavbarLayout = () => (
    <main className="relative flex h-full min-w-0 flex-1 gap-3 overflow-clip rounded-t-4xl bg-surface-background p-4 pb-0 pr-0.5">
        <Navbar />
        <div className="min-w-0 flex-1 overflow-clip">
            <Outlet />
        </div>
    </main>
);

export default NavbarLayout;
